// extracted by mini-css-extract-plugin
export default {"status":"style_status__PRqMm","loading":"style_loading__M925K","statusName":"style_statusName__6j3XE","failed":"style_failed__oOaVo"};